import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const SUGGESTIONS = [
  { label: '回到首页速览', to: '/', icon: 'ri-home-5-line' },
  { label: '浏览热门速览', to: '/hot', icon: 'ri-fire-line' },
  { label: '关于我们', to: '/about', icon: 'ri-information-line' },
  { label: '联系我们', to: '/contact', icon: 'ri-chat-3-line' },
];

export default function NotFound() {
  useEffect(() => {
    document.title = '页面不存在 - 5看料网';
    let robot = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (!robot) {
      robot = document.createElement('meta');
      robot.setAttribute('name', 'robots');
      document.head.appendChild(robot);
    }
    robot.setAttribute('content', 'noindex, follow');
  }, []);

  return (
    <div className="w-full px-4 py-20 md:px-8 md:py-28">
      <div className="mx-auto max-w-2xl text-center">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-compass-3-line text-3xl" aria-hidden="true"></i>
        </span>
        <p className="mt-6 font-heading text-5xl font-black text-primary-500">404</p>
        <h1 className="mt-3 font-heading text-2xl font-bold text-foreground-950">
          这个页面走丢了
        </h1>
        <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600">
          你访问的链接可能已经更新或不存在。不如从下面这些入口重新开始，用三分钟看完今天的速览。
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          {SUGGESTIONS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 font-label text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className={`${item.icon} text-base`} aria-hidden="true"></i>
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}